<script>
export default {
  props: ["clr"]
};
</script>

<template>
  <svg
    id="clip-attachment.1"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path
      id="Path_8384"
      data-name="Path 8384"
      d="M13.076,7.927,8.047,12.956a1.94,1.94,0,0,0,0,2.743h0a1.94,1.94,0,0,0,2.743,0l6.629-6.629a3.556,3.556,0,0,0,0-5.029h0a3.556,3.556,0,0,0-5.029,0L5.761,10.67a5.172,5.172,0,0,0,0,7.315h0a5.172,5.172,0,0,0,7.315,0L17.1,13.961"
      transform="translate(-0.354 -0.25)"
      fill="none"
      :stroke="clr ? clr : '#500FE9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path id="Path_8385" data-name="Path 8385" d="M0,0H22V22H0Z" fill="none" />
  </svg>
</template>
